import { defineStore } from 'pinia'
import { useStorage } from '@vueuse/core'

const STORE_KEY = 'protargeting-personal'

export const usePersonalStore = defineStore(STORE_KEY, () => {
  const email = useStorage<string | undefined>(`${STORE_KEY}-email`, undefined)
  const name = useStorage<string | undefined>(`${STORE_KEY}-name`, undefined)
  const token = useStorage<string | undefined>(`${STORE_KEY}-token`, undefined)
  const signedInAs = useStorage<string | undefined>(`${STORE_KEY}-signed-email`, undefined)

  return { email, name, token, signedInAs }
})
